import { render } from "./solicitudCard.vue?vue&type=template&id=0cd6cb4b&scoped=true"
import script from "./solicitudCard.vue?vue&type=script&lang=js"
export * from "./solicitudCard.vue?vue&type=script&lang=js"

import "./solicitudCard.vue?vue&type=style&index=0&id=0cd6cb4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd6cb4b"]])

export default __exports__